import React from "react";
import { StatamicHtml } from "../../../utils/statamicAssets";

const AccordionItem = ({data}) => {

    const title = data.title;
    const copy = data.copy;

    return(
        <details>
            <summary>
                {title}
            </summary>
            {copy && <StatamicHtml className="accordion-item-copy" html={copy} />}
        </details>
    );
};

export default AccordionItem;
